if (!customElements.get('featured-products')) {
  class FeaturedProducts extends HTMLElement {
    constructor() {
      super();

      this.buttons = [...this.querySelectorAll('[id^="FeaturedProductsButton"]')];
      this.collections = [...this.querySelectorAll('[id^="FeaturedProductsCollection"]')];
      this.descriptions = [...this.querySelectorAll('[id^="FeaturedProductsDescription"]')];
      this.viewAll = [...this.querySelectorAll('[id^="FeaturedProductsViewAll"]')];

      if (!this.buttons.length) {
        return;
      }

      this.buttons.forEach(($button) => {
        $button.addEventListener('click', () => {
          const ids = $button.getAttribute('aria-controls')?.trim().split(' ') || [];
          console.log(ids);
          ids.forEach((id) => {
            const $item = this.querySelector(`[id="${id}"]`);

            if ($item) {
              if (id.includes('Collection')) {
                this.collections.forEach(($c) => {
                  $c.removeAttribute('aria-current');
                });
              }
              if (id.includes('Description')) {
                this.descriptions.forEach(($d) => {
                  $d.removeAttribute('aria-current');
                });
              }
              if (id.includes('ViewAll')) {
                this.viewAll.forEach(($d) => {
                  $d.removeAttribute('aria-current');
                });
              }

              $item.setAttribute('aria-current', 'true');
            }

            this.buttons.forEach(($b) => $b.removeAttribute('aria-current'));
            $button.setAttribute('aria-current', 'true');
          });
        });
      });
    }
  }

  customElements.define('featured-products', FeaturedProducts);
}
